import slice from './Developer.slice';

export const { fetchAccessKeys, setIsLoading, setAccessKeys } = slice.actions;